// Mini-jeu « Débusque l'arnaque » : repérer en temps limité les signaux d'alerte.
import { useEffect, useState } from 'preact/hooks';
import {
  SCAM_MAX_WRONG,
  SCAM_MIN_FOUND,
  SCAM_REWARD_FAIL,
  SCAM_REWARD_SUCCESS,
  SCAM_SECONDS,
  SCAM_SEGMENTS,
} from '../content/scam';
import { t } from '../engine/i18n';

const TOTAL_FLAGS = SCAM_SEGMENTS.filter((segment) => segment.flag).length;

export function ScamGame({ onDone }: { onDone: (found: number, wrong: number) => void }) {
  const [selected, setSelected] = useState<number[]>([]);
  const [secondsLeft, setSecondsLeft] = useState(SCAM_SECONDS);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (finished) return;
    const timer = setInterval(() => setSecondsLeft((seconds) => seconds - 1), 1000);
    return () => clearInterval(timer);
  }, [finished]);

  useEffect(() => {
    if (secondsLeft <= 0) setFinished(true);
  }, [secondsLeft]);

  const found = selected.filter((index) => SCAM_SEGMENTS[index].flag).length;
  const wrong = selected.length - found;

  const toggle = (index: number) =>
    setSelected((current) =>
      current.includes(index) ? current.filter((item) => item !== index) : [...current, index],
    );

  if (finished) {
    const success = found >= SCAM_MIN_FOUND && wrong <= SCAM_MAX_WRONG;
    return (
      <div class="scam">
        <p class={success ? 'tone-good' : ''}>
          {t(success ? 'scam.success' : 'scam.fail', { found, total: TOTAL_FLAGS })}
        </p>
        {wrong > 0 && <p class="muted">{t('scam.wrong', { count: wrong })}</p>}
        <ul class="scam-explanations">
          {SCAM_SEGMENTS.filter((segment) => segment.flag).map((segment) => (
            <li key={segment.text}>
              <strong>{t(segment.text)}</strong> {segment.why ? t(segment.why) : ''}
            </li>
          ))}
        </ul>
        <p>{t('scam.reward', { points: success ? SCAM_REWARD_SUCCESS : SCAM_REWARD_FAIL })}</p>
        <button class="button-primary" onClick={() => onDone(found, wrong)}>
          {t('common.continue')}
        </button>
      </div>
    );
  }

  return (
    <div class="scam">
      <p>{t('scam.intro', { seconds: SCAM_SECONDS })}</p>
      <p class="timer">{t('scam.timeLeft', { seconds: Math.max(0, secondsLeft) })}</p>
      <div class="scam-offer">
        {SCAM_SEGMENTS.map((segment, index) => (
          <button
            key={segment.text}
            class={selected.includes(index) ? 'segment selected' : 'segment'}
            aria-pressed={selected.includes(index)}
            onClick={() => toggle(index)}
          >
            {t(segment.text)}
          </button>
        ))}
      </div>
      <button class="button-primary" onClick={() => setFinished(true)}>
        {t('scam.validate')}
      </button>
    </div>
  );
}
